export function joinClassNames(names: (string | undefined | boolean)[]) {
  return names.filter((name) => !!name && typeof name === "string").join(" ");
}

export function NaNToDetail(num: string | number, value: number | undefined) {
  return isNaN(+num) ? value : +num;
}
// // UTC转中国时间
// export function formatTime_UTC(time: Date) {
//   let y = time.getFullYear();
//   let m = time.getMonth() + 1;
//   let d = time.getDate();
//   let h = time.getHours();
//   let mm = time.getMinutes();
//   let s = time.getSeconds();
//   return (
//     y +
//     "-" +
//     String(m).padStart(2, "0") +
//     "-" +
//     String(d).padStart(2, "0") +
//     " " +
//     String(h).padStart(2, "0") +
//     ":" +
//     String(mm).padStart(2, "0") +
//     ":" +
//     String(s).padStart(2, "0")
//   );
// }
